import { memo } from 'react';

const SkeletonBlock = memo(({ className = '', style, 'aria-label': ariaLabel = 'Loading' }) => (
  <span
    className={`skeleton ${className}`.trim()}
    style={style}
    role="status"
    aria-busy="true"
    aria-label={ariaLabel}
  />
));

SkeletonBlock.displayName = 'SkeletonBlock';

export default SkeletonBlock;
